import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"line-height":"25px"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center"} }
const _hoisted_3 = { style: {"font-size":"19px","font-weight":"600","color":"#000"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"flex-end","align-items":"center","padding-right":"5px"} }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["v-html"]



export default /*@__PURE__*/_defineComponent({
  __name: 'ArrowContent',
  props: {
    heading: {
        type: String,
        default: '',
    },
    content: {
        type: String,
        default: '',
    },
    htmlValue: {
        type: Boolean,
        default: false,
    }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "16" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.heading), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_van_icon, {
                style: {"padding":"10px 0px"},
                name: "arrow",
                size: "15",
                color: "#5f6368"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: 24,
          id: "htmlContent"
        }, {
          default: _withCtx(() => [
            (__props.htmlValue)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"padding-top":"20px","color":"#5f6368"},
                  innerHTML: __props.content
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  style: {"display":"flex","justify-content":"flex-start","padding-top":"20px","color":"#5f6368","margin":"0"},
                  "v-html": __props.content
                }, null, 8, _hoisted_6))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})